"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportInputFieldType = exports.ReportColumnType = void 0;
var ReportColumnType;
(function (ReportColumnType) {
    ReportColumnType["TEXT"] = "TEXT";
    ReportColumnType["NUMBER"] = "NUMBER";
    ReportColumnType["BOOLEAN"] = "BOOLEAN";
    ReportColumnType["DATE"] = "DATE";
    ReportColumnType["DATETIME"] = "DATETIME";
    ReportColumnType["TIME"] = "TIME";
    ReportColumnType["SELECT"] = "SELECT";
})(ReportColumnType = exports.ReportColumnType || (exports.ReportColumnType = {}));
var ReportInputFieldType;
(function (ReportInputFieldType) {
    ReportInputFieldType["TEXT"] = "TEXT";
    ReportInputFieldType["NUMBER"] = "NUMBER";
    ReportInputFieldType["BOOLEAN"] = "BOOLEAN";
    ReportInputFieldType["DATE"] = "DATE";
    ReportInputFieldType["DATETIME"] = "DATETIME";
    ReportInputFieldType["TIME"] = "TIME";
    ReportInputFieldType["SELECT"] = "SELECT";
    ReportInputFieldType["AUTOCOMPLETE"] = "AUTOCOMPLETE";
})(ReportInputFieldType = exports.ReportInputFieldType || (exports.ReportInputFieldType = {}));
//# sourceMappingURL=reporting-types.js.map